
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ChartData, ChartOptions } from 'chart.js';
import { Line } from 'vue-chartjs';
import { renderChart } from '@/features/common/types';

@Component({
  extends: Line,
})
export default class LineChart extends Vue {
  @Prop({ required: true, type: Object }) data!: ChartData;

  private options: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: { display: false },
    scales: {
      yAxes: [{ display: false }],
      xAxes: [{
        gridLines: { display: false },
      }],
    },
  }

  private renderChart!: renderChart;

  mounted(): void {
    this.renderChart(this.data, this.options);
  }
}
